import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FAQs, Help, PagedResponse, SupportServiceConfig } from './support-service.types';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';


@Injectable({
  providedIn: 'root',
})

export class SupportService {
  constructor(private httpClient: HttpClient,
    @Inject('supportServiceConfig') private supportServiceConfig: SupportServiceConfig) { }

  private restServer = this.supportServiceConfig.restServer;

  getFAQs(): Observable<FAQs[]> {
    return this.httpClient.get<PagedResponse>(
      `${this.restServer}/core_application/faq/`
    ).pipe(map((result) => <FAQs[]>result.results));
  }

  getHelp(applicationName: string): Observable<Help[]> {
    return this.httpClient.get<PagedResponse>(
      `${this.restServer}/core_application/help/?application=${applicationName}&page_size=500`
    ).pipe(map((result) => <Help[]>result.results));
  }
}